import { Column, Row, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

interface EnglishLevelDisplayProps {
  cefrLevel: string
  isResponsive?: boolean
}

const EnglishLevelDisplay = ({
  cefrLevel,
  isResponsive = true
}: EnglishLevelDisplayProps) => {
  return (
    <Row className="items-center space-x-4">
      <Column
        className={classNameBuilder(
          'h-44 w-44  items-center overflow-hidden rounded-full bg-electric-indigo-500',
          isResponsive && 'max-lg:h-32 max-lg:w-32'
        )}
      >
        <Row
          className={classNameBuilder(
            'w-full items-center justify-center bg-black/20 pb-4 pt-6',
            isResponsive && 'max-lg:pb-2 max-lg:pt-4'
          )}
        >
          <Text.Translated
            translationKey="oral_expression_level_app_resultado_page"
            fontWeight="bold"
            transform="uppercase"
            align="center"
            className={classNameBuilder(
              'w-[120px] text-center text-[12px] text-white',
              isResponsive && 'max-lg:text-[10px]'
            )}
            size="none"
          />
        </Row>
        <Column
          className={classNameBuilder(
            'white w-full items-center pb-8 pt-8',
            isResponsive && 'max-lg:pb-4 max-lg:pt-4'
          )}
        >
          <Text
            fontWeight="bold"
            transform="uppercase"
            className={classNameBuilder(
              'text-[52px] text-white',
              isResponsive && 'max-lg:text-[42px]'
            )}
          >
            {cefrLevel}
          </Text>
        </Column>
      </Column>
    </Row>
  )
}

export default EnglishLevelDisplay
